export const LOCK_PERIOD_DAYS_AMOUNT = 120;
